module.exports = __webpack_public_path__ + "img/s5_stepimg01-s.f0992406.png";